import React from 'react';

import { ConsentLink, OptionalText } from './SmsConsentLabel.styled';

const privacyPolicyUrl = 'https://kindbody.com/privacy-policy/';
const smsTermsUrl = 'https://kindbody.com/sms-terms-2024/';

const preventCheckboxToggle = (event: React.MouseEvent<HTMLAnchorElement>) => {
  event.stopPropagation();
};

export const SmsConsentLabel: React.FC = () => {
  return (
    <>
      <OptionalText>(OPTIONAL)</OptionalText>
      By checking the box and opting in, I agree to receive SMS messages regarding my account,
      services, updates, notifications, and other related communications from Kindbody. Message
      frequency varies. Message and data rates may apply. Reply STOP to opt out at any time. Reply
      HELP for help. I agree to Kindbody&apos;s{' '}
      <ConsentLink
        href={privacyPolicyUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={preventCheckboxToggle}
      >
        privacy policy
      </ConsentLink>{' '}
      and{' '}
      <ConsentLink
        href={smsTermsUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={preventCheckboxToggle}
      >
        SMS terms of service
      </ConsentLink>
      . By leaving this box unchecked, I will not be opted into this short code campaign.
    </>
  );
};
